<template>
  <div class="term">
    <div class="termlist">
      <term-new :list="applylist" />
    </div>
    <form-data :list="formlist" @getAuth="getAuth" :isterm="isterm" @goterm="goterm" />
  </div>
</template>

<script>
import "./term.less";
import {
  matchinfo,
  prePayorder,
  typeattrtmpls,
  groupattrtmpls,
  editregistergroup
} from "@/libs/api";
import { Cell, CellGroup, Button, Dialog } from "vant";
import TermNew from "@/components/termnew";
import formData from "@/components/form";
import { setStorage, getStorage } from "@/libs/utils";

export default {
  name: "mainapply",
  components: {
    Cell,
    CellGroup,
    Button,
    Dialog,
    TermNew,
    formData
  },
  data() {
    return {
      applylist: {},
      showtypesheet: false,
      radio: "0",
      type: "default",
      show: false,
      userInfoList: [],
      formlist: [],
      isterm: true,
      postparams: {}
    };
  },
  methods: {
    getAuth(data) {
      if (data) {
        let userinfo = getStorage("userInfo");
        var params = Object.assign({}, this.postparams, this.$route.query);
        params.groupjson = JSON.stringify(data);
        params.categoryid = this.applylist.categoryid;
        params.matchid = this.applylist.matchid;
        params.typeid = this.applylist.typeid;
        params.urid = userinfo.urid;
        params.token = userinfo.token;
        editregistergroup(params).then(res => {
          if (res.status == 200) {
            this.$router.push({
              name: "manage",
              params: {
                rgid: res.data.rgid,
                rrid: params.rrid,
                typeid: params.typeid,
                categoryid: params.categoryid,
                matchid: params.matchid
              },
              // query: this.$route.query
            });
          }
        });
      }
    },
    goterm(val) {
      if (val == "条款") {
        var src = escape(this.applylist.disclaimer);
        // console.log(this.applylist.disclaimer)
        // window.location.href = this.applylist.disclaimer
        this.$router.push({
          name: "terms",
          params: { index: src },
          query: this.$route.query
        });
        // window.location.href = this.applylist.disclaimer
      }
    }
  },
  mounted() {
    this.$nextTick(() => {      
      let userinfo = getStorage("userInfo");
      let param = this.$route.params
      let query = this.$route.query
      let arr = Object.keys(param);
      if(arr.length == 0){
        this.postparams = getStorage('term')
      }else{
        this.postparams = this.$route.params
        setStorage('term',this.postparams,true)
      }
      let matchid = this.postparams.matchid;
      let typeid = this.postparams.typeid;
      let urid = userinfo.urid;
      let token = userinfo.token;
      matchinfo({
        matchid: matchid,
        typeid: typeid,
        urid: urid,
        token: token,
        rgid: this.postparams.rgid || query.rgid,
        rrid: this.postparams.rrid || query.rrid
      }).then(res1 => {
        if (res1.status == 200) {
          this.applylist = res1.data;
        }
      });
      groupattrtmpls({
        matchid: matchid,
        typeid: typeid,
        urid: urid,
        token: token,
        rgid: this.postparams.rgid || query.rgid,
        rrid: this.postparams.rrid || query.rrid
      }).then(res2 => {
        if (res2.status == 200) {
          this.formlist = res2.data.attrs;
        }
      });
    });
  }
};
</script>